import { combineReducers } from "redux";
import mType from "./measurementTypes";
import winchType from "./winchType";
import drumWidth from "./drumWidth";
import drumSurface from "./drumSurface";
import motorType from "./motorType";
import rotationDirection from "./rotationDirection";
import motorLayout from "./motorLayout";
import pressureRoller from "./pressureRoller";
import ropeEndControl from "./ropeEndControl";
import paintFinish from "./paintFinish";
import wireRope from "./wireRope";
import fasteners from "./fasteners";
import externalBrakeRelease from "./externalBrakeRelease";
import throttleValve from "./throttleValve";
import loadMeasuring from "./loadMeasuring";
import userDetails from "./userDetails";
import previewHtml from "./previewHtml";
import pdfLink from "./pdfLink";
import userId from "./updateUserId";
import productId from "./productId";
import orderCode from "./orderCode";
import previewStatus from "./updatePreviewStatus";
import countryList from "./countryList";
import cleared from "./clearedStatus";
import {
  validPaint,
  validRot,
  validMotorLayout,
  validMotorType,
  validWinch
} from "./validations";

export default combineReducers({
  mType,
  winchType,
  drumWidth,
  drumSurface,
  motorType,
  rotationDirection,
  motorLayout,
  pressureRoller,
  ropeEndControl,
  paintFinish,
  wireRope,
  fasteners,
  externalBrakeRelease,
  throttleValve,
  loadMeasuring,
  userDetails,
  previewHtml,
  pdfLink,
  userId,
  productId,
  orderCode,
  countryList,
  previewStatus,
  cleared,
  validWinch,
  validRot,
  validMotorLayout,
  validMotorType,
  validPaint
});



// WEBPACK FOOTER //
// ./src/reducers/index.js